const endpoints = {
  // Authentication endpoints
  login: '/api/users/login/',
  signup: '/api/users/register/',
  logout: '/api/users/logout/',
  refreshToken: '/api/users/refresh-token/',
  verifyEmail: '/api/users/verify-email/',
  verifyEmailOtp: '/api/users/verify-otp/',
  resendVerification: '/api/users/request-otp/',

  // Password reset endpoints
  requestPasswordResetOtp: '/api/users/request-forget-password/',
  verifyPasswordResetOtp: '/api/users/verify-otp/',
  resetPassword: '/api/users/reset-password/',
  resetPasswordWithToken: '/api/users/reset-password/', // Base endpoint for token-based reset
  // seller registration endpoints
  sellerRegistration: '/api/users/become-seller/',
  // Profile endpoints
  getSellerProfile: '/api/users/profile/get-seller-profile/',
  getSellerInfo: '/api/users/seller-info/',
  getSellerReviews: '/api/users/seller-reviews/',
  updateSellerInfo: '/api/users/seller-info/update/',
  getWallet: '/api/users/wallet/',
  getDeliveryInfo: '/api/users/delivery-info/',
  updateDeliveryInfo: '/api/users/delivery-info/update/',
  updateSellerProfile: '/api/users/profile/update-seller-profile/',
  updateBuyerProfile: '/api/users/profile/update-buyer-profile/',
  searchCard: 'api/cards/search-card/?card_name=Mint',
  // Creates order and initializes payment, returns redirect_url (if any)
  placeOrder: '/api/orders/create-order/',
  getRate: '/api/orders/get-rate/',
  createLabel: '/api/orders/create-label/',
  trackingOrder: '/api/orders/track-order/',
  submitRating: '/api/orders/submit-rating/',
  getWaybill: '/api/orders/get-waybill/',
  // Payment endpoints
  requestPayout: '/payment/payouts/request/',
  getPayoutsList: '/payment/payouts/list/',
  reviewPayout: '/payment/payouts/review/',
  // Bank details endpoints
  addBankDetails: '/payment/bank-details/add/',
  updateBankDetails: '/payment/bank-details/update/',
  deleteBankDetails: '/payment/bank-details/delete/',
  listBankDetails: '/payment/bank-details/list/',
  // Admin endpoints
  adminDashboardStats: '/api/dashboard/admin-dashboard-stats/',
  getUsersList: '/api/users/get-users-list/',
  activateUser: '/api/users/activate-user/',
  deactivateUser: '/api/users/deactivate-user/',
  // Card listing endpoints
  updateCardListing: '/api/cards/update-card-listing/',
  getCardsByIds: '/api/cards/cards-by-ids/',
};

export default endpoints;
